import { useEffect } from "react";

// Sets the per-route document title and meta description without extra deps.
// Title format: "<Page Name> · Project in a Box"
export default function useSeo(title, description) {
  useEffect(() => {
    const fullTitle = title ? `${title} · Project in a Box` : "Project in a Box";
    document.title = fullTitle;

    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
}
